export const swurfMapId = "306a13c6fbc205e"
